/**
 * @generated SignedSource<<879141cecc8cc875aa8bd7a52cb7d14e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportEventsAttendedStatisticCardFragment$data = {
  readonly eventsAttendedReport: {
    readonly allTime: number;
    readonly sinceYesterday: number | null;
  };
  readonly " $fragmentType": "MemberReportEventsAttendedStatisticCardFragment";
};
export type MemberReportEventsAttendedStatisticCardFragment$key = {
  readonly " $data"?: MemberReportEventsAttendedStatisticCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportEventsAttendedStatisticCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportEventsAttendedStatisticCardFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "GenericReportingResponse",
      "kind": "LinkedField",
      "name": "eventsAttendedReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "allTime",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "sinceYesterday",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "fe30bfa3333b0824f12641558d7c0ed7";

export default node;
